<template>
  <v-layout row wrap justify-center>
    <send-transfer-form
      @saved="saved"
      v-model="transfer"
      class="flex xs12 shadow mb-4"
      v-if="initList && !reportView"
    />
    <bill-preview v-model="dialog">
      <send-transfer-bill slot="form" v-bind="showItem" />
    </bill-preview>

    <form-dialog v-model="editDialog" :title="$t('edit_bill')" width="1000px">
      <send-transfer-form
        ref="edit"
        @saved="saved"
        v-if="editDialog"
        v-model="itemForEdit"
        class="flex xs12 shadow pa-0"
      />
    </form-dialog>

    <v-card class="shadow flex xs12 pa-0">
      <div
        class="
          py-1
          px-3
          secondary
          white--text
          font-weight-bold
          di-flex
          justify-center
          align-center
        "
        v-if="!accountView"
      >
        <span class="py-1">{{ $t(label) }}</span>
        <v-spacer />
        <div v-if="!dashboardView && !accountView">
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <v-btn color="white" class="py-0 ma-0" flat dark v-on="on">
                <!-- <v-icon class="mx-2">more_vert</v-icon> -->
                <strong class="mt-1"> {{ selected_currency.name }} </strong>
              </v-btn>
            </template>

            <v-list>
              <v-list-tile
                :key="index"
                @click="currencyChanged(item)"
                v-for="(item, index) in currencies"
              >
                <v-list-tile-title>{{ item.name }}</v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </div>
      </div>
      <v-card-text class="pt-3">
        <v-layout row wrap class="flex-row align-center justify-start">
          <v-checkbox
            singleLine
            hideDetails
            color="primary"
            @change="initData"
            v-model="filter_date"
            style="max-width: 24px"
            v-if="!dashboardView && !accountView"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            format="YYYY-MM-DD"
            v-model="start_date"
            value-type="YYYY-MM-DD"
            input_id="start_date_send_tr"
            :placeholder="$t('start_date')"
            :disabled="loading && !filter_date"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-date
            singleLine
            :hideDetails="true"
            @input="initData"
            v-model="end_date"
            format="YYYY-MM-DD"
            value-type="YYYY-MM-DD"
            :placeholder="$t('end_date')"
            input_id="start_date_send_end"
            :disabled="loading && !filter_date"
            v-if="!dashboardView && !accountView"
            class="mx-2 flex xs12 md2 hide-details"
          />
          <v-spacer />
          <v-text-field
            outline
            hide-details
            v-model="search"
            v-if="!dashboardView"
            style="max-width: 400px"
            class="flex xs12 rounded"
            :placeholder="$t('search')"
            prepend-inner-icon="search"
          />
          <v-btn
            flat
            icon
            class="mx-0"
            @click="initData"
            :loading="loading"
            color="grey darken-2"
            v-if="!dashboardView"
          >
            <v-icon>refresh</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(false)"
          >
            <v-icon>print</v-icon>
          </v-btn>
          <v-btn
            flat
            icon
            class="mx-0"
            color="grey darken-2"
            @click="printTable(true)"
          >
            <v-icon>file_download</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table
          ref="tbl"
          :loading="loading"
          :headers="headers"
          disable-initial-sort
          :items="computedItems"
          :total-items="meta.total"
          :pagination.sync="pagination"
          :rows-per-page-items="per_page"
          :search="!initList ? search || externalSearch : ''"
        >
          <template slot="items" slot-scope="props">
            <tr @click="props.expanded = !props.expanded">
              <td :class="{ red: props.item.deleted_at }">
                {{ props.index + 1 }}
              </td>
              <td>{{ props.item.branch.name }}</td>
              <td>{{ props.item.number }}</td>
              <td>{{ props.item.receiver.name }}</td>
              <td
                @dblclick="
                  $emit(
                    'customer_changed',
                    props.item.customer_id,
                    props.item.customer
                  )
                "
              >
                {{ props.item.details.name }}
              </td>
              <td
                @dblclick="
                  $emit(
                    'customer_changed',
                    props.item.receiver_customer_id,
                    props.item.receiver_customer
                  )
                "
              >
                {{ props.item.details.receiver_name }}
              </td>
              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >
                {{ props.item.amount | currency }}
              </td>
              <td
                :class="{
                  'red--text': props.item.amount < 0,
                  'activeColor--text': props.item.amount > 0,
                }"
              >
                {{ smbl(props.item.currency_id) }}
              </td>
              <!-- <td>{{ props.item.rate }}</td>
              <td
                :class="{
                  'red--text': props.item.exchanged < 0,
                  'activeColor--text': props.item.exchanged > 0,
                }"
              >
                {{
                  props.item.exchanged
                    | currency({
                      symbol: smbl(props.item.receiver_currency_id),
                    })
                }}
              </td> -->
              <td
                :class="{
                  'red--text': props.item.commission_amount < 0,
                  'activeColor--text': props.item.commission_amount > 0,
                }"
              >
                {{
                  props.item.commission_amount
                    | currency({
                      symbol: smbl(props.item.commission_currency_id),
                    })
                }}
              </td>
              <td
                :class="{
                  'red--text': props.item.paid_commission_amount < 0,
                  'activeColor--text': props.item.paid_commission_amount > 0,
                }"
              >
                {{
                  props.item.paid_commission_amount
                    | currency({
                      symbol: smbl(props.item.paid_commission_currency_id),
                    })
                }}
              </td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.date | persianDateFilter(true) }}</td>
              <td>{{ props.item.date | persianDateFilter }}</td>
              <td>{{ props.item.time }}</td>
              <td>{{ props.item.risk_category }}</td>
              <td v-if="trashed">{{ props.item.deleted_at }}</td>
              <td v-if="reportView">
                {{ props.item.user && props.item.user.name }}
              </td>
              <td>
                <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  v-if="can.view"
                  color="grey darken-1"
                  @click="showTransfer(props.item)"
                >
                  <v-icon>launch</v-icon>
                </v-btn>
                <v-btn
                  flat
                  small
                  icon
                  class="ma-0"
                  color="grey darken-1"
                  @click="editItem(props.item)"
                  v-if="can.edit && props.item.editable"
                >
                  <v-icon>edit</v-icon>
                </v-btn>
                <v-btn
                  flat
                  icon
                  small
                  class="ma-0"
                  color="grey darken-1"
                  @click="deleteItem(props.item)"
                  v-if="can.delete && props.item.editable"
                >
                  <v-icon>delete_outline</v-icon>
                </v-btn>
              </td>
            </tr>
          </template>
          <template v-slot:expand="{ item }">
            <v-divider></v-divider>
            <file-viewer :files="item.files" />
            <!-- <send-transfer-detail :transfer="item" /> -->
          </template>
          <template slot="footer">
            <tr
              :key="key"
              class="font-weight-bold"
              v-for="(value, key) in summery.currencies"
            >
              <td colspan="5">{{ $t("total") }} {{ smbl(value) }}</td>
              <td colspan="2  " class="lr--text px-3">
                {{ summery.amount[value] | currency({ symbol: smbl(value) }) }}
              </td>
              <!-- <td>
                {{
                  summery.exchanged[value] | currency({ symbol: smbl(value) })
                }}
              </td> -->
              <td>
                {{
                  summery.commission_amount[value]
                    | currency({ symbol: smbl(value) })
                }}
              </td>
              <td colspan="100%">
                {{
                  summery.paid_commission_amount[value]
                    | currency({ symbol: smbl(value) })
                }}
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-layout>
</template>

<script>
import curjs from "currency.js";
import debounce from "@/plugins/vDebounce";
import { customersMixin } from "@/mixins/index.js";

export default {
  mixins: [customersMixin],
  props: {
    pep: { default: false },
    lctr: { default: false },
    st_date: { default: null },
    en_date: { default: null },
    date: { default: null },
    trashed: { default: false },
    initList: { default: true },
    externals: { default: false },
    reportView: { default: false },
    accountView: { default: false },
    externalSearch: { default: "" },
    transfers: { default: () => [] },
    dashboardView: { default: false },
    suction_checked: { default: false },
    branch_id: { default: undefined },
    customer_id: { default: undefined },
    brnch_name: { default: "" },
    risk_category: { default: undefined},
    label: { default: "send_transfers" },
  },

  data: () => ({
    items: [],
    search: "",
    dialog: false,
    editIndex: -1,
    loading: false,
    selected_currency: {
      id: undefined,
      name: "ALl Currencies",
    },
    editDialog: false,
    showItem: {
      sender: {},
      receiver: {},
      transfer: { details: {} },
    },
    defaultItem: {
      details: {},
    },
    transfer: {
      files: [],
      details: {},
      date: new Date().toLocaleDateString("en-ca"),
    },
    itemForEdit: {
      details: {},
      files: [],
      date: new Date().toLocaleDateString("en-ca"),
    },
    meta: {
      total: 0,
      perPage: 0,
      current_page: 0,
    },
    filter_date: true,
    pagination: { page: 1, rowsPerPage: 100 },
    end_date: new Date().toLocaleDateString("en-ca"),
    start_date: new Date().toLocaleDateString("en-ca"),
  }),
  computed: {
    currencies() {
      let items = this.initialData.currencies;
      return [{ id: undefined, name: "ALl Currencies" }, ...items];
    },
    computedItems: (vm) => (vm.initList ? vm.items : vm.transfers),

    system() {
      let system = this.initialData.customers.find((x) => x.type == "system");
      return system ? system : {};
    },

    summery() {
      let amount = {};
      let exchanged = {};
      let commission_amount = {};
      let paid_commission_amount = {};
      let currencies = {};

      this.computedItems.forEach((item) => {
        //sum amounts by currency
        if (!amount[item.currency_id]) amount[item.currency_id] = 0;
        amount[item.currency_id] = amount[item.currency_id] + item.amount;

        // sum exchenges by currency
        if (!exchanged[item.receiver_currency_id])
          exchanged[item.receiver_currency_id] = 0;
        exchanged[item.receiver_currency_id] =
          exchanged[item.receiver_currency_id] + item.exchanged;

        //sum comission amounts by currency
        if (!commission_amount[item.commission_currency_id])
          commission_amount[item.commission_currency_id] = 0;
        commission_amount[item.commission_currency_id] =
          commission_amount[item.commission_currency_id] +
          item.commission_amount;

        //sum comission amounts by currency
        if (!paid_commission_amount[item.paid_commission_currency_id])
          paid_commission_amount[item.paid_commission_currency_id] = 0;
        paid_commission_amount[item.paid_commission_currency_id] =
          paid_commission_amount[item.paid_commission_currency_id] +
          item.paid_commission_amount;

        // add amount or exchange currency to used list
        if (item.currency_id) currencies[item.currency_id] = item.currency_id;
        if (item.receiver_currency_id)
          currencies[item.receiver_currency_id] = item.receiver_currency_id;
        if (item.commission_currency_id)
          currencies[item.commission_currency_id] = item.commission_currency_id;

        if (item.paid_commission_currency_id)
          currencies[item.paid_commission_currency_id] =
            item.paid_commission_currency_id;
      });
      return {
        amount,
        exchanged,
        commission_amount,
        paid_commission_amount,
        currencies,
      };
    },

    can() {
      return {
        add: this.userCan("add_send_transfers"),
        view: this.userCan("view_send_transfers"),
        edit: this.userCan("edit_send_transfers"),
        delete: this.userCan("delete_send_transfers"),
        any:
          this.userCan("edit_send_transfers") ||
          this.userCan("view_send_transfers") ||
          this.userCan("delete_send_transfers"),
      };
    },
    headers: (vm) => {
      let items = [
        {
          width: "30px",
          value: "index",
          hidePrint: true,
          sortable: false,
          text: vm.$t("number"),
        },
        {
          sortable: false,
          value: "branch.name",
          text: vm.$t("branch"),
        },
        {
          value: "number",
          sortable: false,
          types: ["send", "receive"],
          text: vm.$t("transfer_number"),
        },
        {
          sortable: false,
          value: "receiver.name",
          text: vm.$t("destination"),
        },
        {
          sortable: false,
          value: "details.name",
          text: vm.$t("sender"),
        },
        {
          sortable: false,
          text: vm.$t("receiver"),
          value: "details.receiver_name",
        },
        {
          value: "amount",
          sortable: false,
          text: vm.$t("amount"),
          computed: (item) => curjs(item.amount).format({ symbol: "" }),
        },
        {
          width: 30,
          value: "currency",
          sortable: false,
          text: vm.$t("currency"),
          computed: (item) => `${vm.smbl(item.currency_id)}`,
        },
        // {
        //   value: "rate",
        //   width: "30px",
        //   sortable: false,
        //   text: vm.$t("rate"),
        // },
        // {
        //   sortable: false,
        //   value: "exchanged",
        //   text: vm.$t("total"),
        //   computed: (item) =>
        //     `${item.exchanged} ${vm.smbl(item.receiver_currency_id)}`,
        // },
        {
          sortable: false,
          text: vm.$t("commission"),
          value: "commission_amount",
          computed: (item) =>
            `${curjs(item.commission_amount).format({ symbol: "" })} ${vm.smbl(
              item.commission_currency_id
            )}`,
        },
        {
          sortable: false,
          text: vm.$t("paid_commission"),
          value: "paid_commission_amount",
          computed: (item) =>
            `${curjs(item.paid_commission_amount).format({
              symbol: "",
            })} ${vm.smbl(item.paid_commission_currency_id)}`,
        },
        {
          width: "400px",
          sortable: false,
          value: "description",
          text: vm.$t("description"),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("persian_date"),
          computed: (item) => vm.persianDateFilter(item.date, true),
        },
        {
          value: "date",
          width: "120px",
          sortable: false,
          text: vm.$t("date"),
          computed: (item) => vm.persianDateFilter(item.date),
        },
        {
          value: "time",
          width: "120px",
          sortable: false,
          text: vm.$t("time"),
        },
        {
          width: "120px",
          sortable: false,
          value: "risk_category",
          text: vm.$t("risk_profile"),
        },
      ];
      if (vm.trashed) {
        items.push({
          sortable: false,
          value: "deleted_at",
          text: vm.$t("deleted_at"),
        });
      }
      if (vm.reportView) {
        items.push({
          sortable: false,
          value: "user.name",
          text: vm.$t("user"),
        });
      }
      items.push({
        sortable: false,
        value: "actions",
        hidePrint: true,
        text: vm.$t("actions"),
      });
      return items;
    },
  },
  methods: {
    reset() {
      this.editIndex = -1;
      this.editDialog = false;
      let currentTime = new Date();
      this.transfer = this.itemForEdit = {
        id: null,
        files: [],
        date: this.transfer.date,
        time: currentTime.toLocaleTimeString([], { hour12: false }),
        sender_id: null,
        receiver_id: null,
        details: {
          name: null,
          phones: [],
          place_of_birth: null,
          date_of_birth: null,
          doctype: "passport",
          receiver_doctype: "passport",
          docno: "",
          nationality: "",
          issue_date: null,
          expire_date: null,
          occupation: null,
          relationship: null,
          source_of_fund: null,
          purpose_of_transaction: null,
          address: null,
          nature_of_bussiness: null,
          receiver_name: null,
          receiver_nationality: null,
          receiver_place_of_birth: null,
          receiver_date_of_birth: null,
          receiver_address: null,
        },
        currency_id: null,
        receiver_currency_id: null,
        rate: 1,
        done: 1,
        amount: null,
        exchanged: 0,
        description: "",
        type: "send",
        number: null,
        suction_checked: false,
        risk_category: "Low",
        has_commission: true,
        commission_amount: null,
        commission_currency_id: null,
        paid_commission_amount: null,
        paid_commission_currency_id: null,
        customer_id: this.system.id,
        receiver_customer_id: this.system.id,
      };
    },

    initData() {
      if (!this.initList) return;
      this.loading = true;
      let {
        pep,
        search,
        trashed,
        externals,
        end_date,
        branch_id,
        start_date,
        reportView,
        filter_date,
        customer_id,
        suction_checked,
        risk_category,
      } = this;
      const { page, rowsPerPage } = this.pagination;
      let params = {
        pep,
        page,
        search,
        trashed,
        externals,
        end_date,
        branch_id,
        reportView,
        start_date,
        customer_id,
        type: "send",
        filter_date,
        risk_category,
        suction_checked,
        per_page: rowsPerPage,
        currency_id: this.selected_currency.id,
      };
      this.axios
        .get(`transfers`, { params })
        .then((resp) => {
          this.items = resp.data.data;
        })
        .catch((er) => {
          console.log(er);
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },

    saved(payload) {
      this.editDialog = false;
      if (this.editIndex < 0) this.computedItems.push(payload);
      else this.computedItems.splice(this.editIndex, 1, payload);
      this.$emit("saved", payload);
      this.reset();
    },

    currencyChanged(item) {
      this.selected_currency = item;
      this.initData();
    },

    showTransfer(item) {
      this.showItem = {
        transfer: item,
        sender: item.sender,
        receiver: item.receiver,
      };
      this.dialog = true;
    },

    editItem(item) {
      this.editIndex = this.computedItems.indexOf(item);
      this.itemForEdit = Object.assign({}, item);
      this.editDialog = true;
    },

    deleteItem(item) {
      let vm = this;
      this.$alert("transfers/" + item.id).then(() => {
        if (vm.computedItems)
          vm.computedItems.splice(vm.computedItems.indexOf(item), 1);
        this.getCustomers();
        vm.$emit("saved");
      });
    },

    printTable(excel) {
      let footers = [];
      for (let currency in this.summery.currencies) {
        footers.push(`
          <td colspan="5" class="px-2 font-weight-bold lr--text">${this.$t(
            "total"
          )} ${this.smbl(currency)}</td>
          <td colspan="2" class="px-2 font-weight-bold">${
            this.summery.amount[currency]
          } ${this.smbl(currency)}</td>
          <td class="px-2 font-weight-bold">${
            this.summery.commission_amount[currency]
          } ${this.smbl(currency)}</td>
          <td colspan="100%" class="px-2 font-weight-bold lr--text">${
            this.summery.paid_commission_amount[currency]
          } ${this.smbl(currency)}</td>
        `);
      }
      let headers = this.headers.filter((x) => !x.hidePrint);
      if (this.lctr || this.reportView)
        headers.push(
          {
            value: "details.source_of_fund",
            text: this.$t("source_of_fund"),
          },
          {
            value: "details.purpose_of_transaction",
            text: this.$t("purpose_of_transaction"),
          },
          {
            value: "details.father_name",
            text: this.$t("father_name"),
          },
          {
            value: "details.doctype",
            text: this.$t("doc_type"),
          },
          {
            value: "details.docno",
            text: this.$t("doc_no"),
          },
          {
            value: "details.address",
            text: this.$t("address"),
          },
          {
            value: "details.pretty_phones",
            text: this.$t("phones"),
          },
          {
            value: "details.place_of_birth",
            text: this.$t("place_of_birth"),
          },
          {
            value: "details.date_of_birth",
            text: this.$t("date_of_birth"),
          }
        );
      let data = {
        footers,
        headers,
        landscape: true,
        brnch_name: `${this.$t("send_transfers")}${
          this.pep ? " -" + this.$t("pep") + " -" : ""
        }${this.externals ? " -" + this.$t("externals") + " -" : ""}${
          this.suction_checked ? " -" + this.$t("suction_checked") + " -" : ""
        } ${this.brnch_name}`,
        items: this.$refs.tbl.filteredItems,
        title: `${this.$t("from")} ( ${
          this.initList ? this.start_date : this.st_date
        }  ${this.persianDateFilter(
          this.initList ? this.start_date : this.st_date,
          true
        )} ) ${this.$t("to")} ( ${
          this.initList ? this.end_date : this.en_date
        } ${this.persianDateFilter(
          this.initList ? this.end_date : this.en_date,
          true
        )} )`,
      };

      if (excel)
        return this.xl_tables(data, "send-remittance", this.LONG_APP_NAME);
      this.$store.commit("ReportsModule/setTableData", data);
      this.$router.push("/print");
    },
  },

  created() {
    this.reset();
  },

  watch: {
    pagination: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    branch_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    customer_id: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    trashed: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    externals: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    pep: {
      handler() {
        this.initData();
      },
      deep: true,
    },

    suction_checked: {
      handler() {
        this.initData();
      },
      deep: true,
    },
    risk_category: {
      handler() {
        this.initData();
      },
      deep: true,
    },  
    search: debounce(function (newVal) {
      this.initData(newVal);
    }, 1000),
  },
};
</script>
